import { render } from "./NumberForm.vue?vue&type=template&id=d59f9524&scoped=true"
import script from "./NumberForm.vue?vue&type=script&lang=js"
export * from "./NumberForm.vue?vue&type=script&lang=js"

import "./NumberForm.vue?vue&type=style&index=0&id=d59f9524&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d59f9524"]])

export default __exports__